import { Box } from "@mui/material";
import "leaflet/dist/leaflet.css";
import React, { useEffect, useRef } from "react";

const CABINETS = [
  {
    lat: 43.6098,
    lng: 1.5008,
    name: "As Cambiots  Balma",
    addr: "8 Route de Mons, 31130 Balma",
    color: "#2D4A3A",
  },
  {
    lat: 43.7708,
    lng: 1.4632,
    name: "Maison Aphéléia  Castelnau",
    addr: "164 Allée du Camp del Rey, 31620 Castelnau-d'Estrétefonds",
    color: "#C4614C",
  },
];

const CabinetsMap = () => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    if (mapRef.current) return;

    import("leaflet").then((L) => {
      if (cancelled || mapRef.current || !containerRef.current) return;

      const Lx = L.default || L;

      mapRef.current = Lx.map(containerRef.current, {
        center: [43.693, 1.482],
        zoom: 10,
        scrollWheelZoom: false,
        zoomControl: true,
      });

      Lx.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "© OpenStreetMap",
        maxZoom: 18,
      }).addTo(mapRef.current);

      CABINETS.forEach((cab) => {
        const icon = Lx.divIcon({
          className: "",
          html: `<div style="
            width:22px;height:22px;
            border-radius:50%;
            background:${cab.color};
            border:3px solid #fff;
            box-shadow:0 3px 10px rgba(0,0,0,.4);
          "></div>`,
          iconSize: [22, 22],
          iconAnchor: [11, 11],
          popupAnchor: [0, -14],
        });

        Lx.marker([cab.lat, cab.lng], { icon })
          .addTo(mapRef.current)
          .bindPopup(
            `<strong style="font-size:.82rem">${cab.name}</strong><br><span style="font-size:.75rem;color:#555">${cab.addr}</span>`,
          );
      });
    });

    return () => {
      cancelled = true;
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  return <Box ref={containerRef} style={{ width: "100%", height: "100%" }} />;
};

export default CabinetsMap;
